import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";

import { type GetTagsQuery, type GetTagsResponse, getTagsResponseSchema } from "../types/tag";

interface UseGetTagsParams extends GetTagsQuery {
  enabled?: boolean;
}

export function useGetTags(
  params: UseGetTagsParams,
  options?: UseGetQueryOptions<GetTagsResponse>
) {
  const { entityType } = params;
  const enabled = params.enabled ?? true;

  const queryParams = new URLSearchParams();

  if (entityType) {
    queryParams.append("filter[entityType]", entityType);
  }

  const queryString = queryParams.toString();
  const url = `${environmentConfig.REACT_APP_BASE_API_URL}/tags${
    queryString ? `?${queryString}` : ""
  }`;

  return useGetQuery({
    url,
    responseSchema: getTagsResponseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_TAG_FAILURE,
      userErrorMessage: "Something went wrong while loading tags.",
    },
    staleTime: 60 * 1000 * 5,
    enabled: enabled && Boolean(entityType),
    ...options,
  });
}
